let is_mobile = false;

if (991 >= window.innerWidth) is_mobile = true;

const responsiveCarousel = (selector) => {
  // Get Carousel collection
  const elements = document.getElementsByClassName(selector);
  // Check if collection isn't empty
  if (0 === elements.length || !elements) return false;

  Array.prototype.map.call(elements, element => {
    let carousel = new Glide('.sdc-responsive-carousel', {
      type: 'slider',
      perView: 1,
      gap: 32,
      keyboard: false,
      bound: true,
      dragThreshold: false,
    });

    carousel.mount()
  });

}

document.addEventListener('DOMContentLoaded', (event) => {
  // Run slider only on screen less than 992p
  if (!is_mobile) return false;

  responsiveCarousel('hero-responsive-carousel');

  // Email form
  let emailForms = document.querySelectorAll('.sdc-form')
  if (!emailForms) return

  emailForms.forEach(emailForm => {



    const redirect = async () => {
      let emailValue = emailForm['user-email'].value,
        url = emailForm.querySelector('.request-demo-url')
        
      await SegmentAnalytics.Identify(getUUID(), { email: emailValue });
      await SegmentAnalytics.Track('try-for-free', { email: emailValue });

      window.location.href = await url.value;
    }

    new SDC_Form_Handler(emailForm, redirect)
  })

})
